import { useState } from 'react';
import { admin, type XpKindCount, type TopXpUser, type BadgeCount } from '../../lib/api';
import { useApi } from '../../hooks/useApi';
import { DataTable, Tabs, type Column } from '../../components/ui';
import { useAdminT } from './adminI18n';

function handle(id: string) {
  return `#${id.replace(/-/g, '').slice(-4).toUpperCase()}`;
}

export default function AdminGamificationPage() {
  const t = useAdminT();
  const [days, setDays] = useState(30);
  const a = useApi(() => admin.gamificationAudit(days, 20), [days]);
  const d = a.status === 'success' ? a.data : null;

  const kindCols: Column<XpKindCount>[] = [
    { key: 'kind', header: t('gaudit.byKind'), mono: true, render: (r) => r.kind },
    { key: 'xp', header: 'XP', align: 'right', mono: true, render: (r) => String(r.xp) },
    { key: 'count', header: t('gaudit.events'), align: 'right', mono: true, render: (r) => String(r.count) },
  ];
  const userCols: Column<TopXpUser>[] = [
    { key: 'user_id', header: t('gaudit.user'), mono: true, render: (r) => handle(r.user_id) },
    { key: 'total_xp', header: 'XP', align: 'right', mono: true, render: (r) => String(r.total_xp) },
    { key: 'events', header: t('gaudit.events'), align: 'right', mono: true, render: (r) => String(r.events) },
  ];
  const badgeCols: Column<BadgeCount>[] = [
    { key: 'badge_id', header: t('gaudit.badges'), mono: true, render: (r) => r.badge_id },
    { key: 'count', header: '#', align: 'right', mono: true, render: (r) => String(r.count) },
  ];

  return (
    <div className="admin-page">
      <header className="admin-page__head">
        <h1>{t('gaudit.title')}</h1>
        <p className="admin-page__sub">{t('gaudit.subtitle')}</p>
      </header>
      <div className="admin-toolbar">
        <Tabs value={String(days)} onChange={(v) => setDays(Number(v))}
          items={[{ key: '7', label: t('cost.range7') }, { key: '30', label: t('cost.range30') }, { key: '90', label: t('cost.range90') }]} />
      </div>

      <div className="admin-stats">
        <div className="admin-stat is-accent">
          <span className="admin-stat__label">{t('gaudit.totalXp')}</span>
          <span className="admin-stat__value">{d ? d.total_xp.toLocaleString() : '—'}</span>
        </div>
        <div className="admin-stat">
          <span className="admin-stat__label">{t('gaudit.events')}</span>
          <span className="admin-stat__value">{d ? d.total_events : '—'}</span>
        </div>
      </div>

      <section className="admin-section">
        <div className="sec-head"><h2>{t('gaudit.byKind')}</h2></div>
        <DataTable columns={kindCols} rows={d?.by_kind ?? []} rowKey={(r) => r.kind}
          loading={a.status === 'loading'} empty={t('emptyGeneric')} />
      </section>
      <section className="admin-section">
        <div className="sec-head"><h2>{t('gaudit.topUsers')}</h2></div>
        <DataTable columns={userCols} rows={d?.top_users ?? []} rowKey={(r) => r.user_id}
          loading={a.status === 'loading'} empty={t('emptyGeneric')} />
      </section>
      <section className="admin-section">
        <div className="sec-head"><h2>{t('gaudit.badges')}</h2></div>
        <DataTable columns={badgeCols} rows={d?.badges ?? []} rowKey={(r) => r.badge_id}
          loading={a.status === 'loading'} empty={t('emptyGeneric')} />
      </section>
    </div>
  );
}
